import { useState, useEffect } from "react";
import { getLive } from "../../network/lib/hallDetails.js";
import { handleContent } from "../utils/helper.js";
import parse from "html-react-parser";
import hallBackImg from "../../assests/images/hall/Hall26.jpg";

function Halls() {
  const [hallDetails, setHallDetails] = useState();

  useEffect(() => {
    !hallDetails && populateHallDetails();
  }, []);

  function populateHallDetails() {
    getLive().then((res) => {
      if (res.status == 200) {
        setHallDetails(res.data);
      }
    });
  }

  const contents = hallDetails && (
    <div className="Row">
      <div className="Cell" style={{ textAlign: "left", backgroundImage: `url(${hallBackImg})`,border: '3px solid #fe6902', borderRadius: '40px', 
                                backgroundRepeat: 'repeat-y',backgroundPosition :'right', padding:"10px 25px"}}>
        <div style={ { paddingLeft: '10px', color: 'black',} }>
          <table
            cellSpacing="0"
            style={{ width: "797px", borderCollapse: "collapse" }}
          >
            <tbody>
              <tr>
                <th scope="col">&nbsp;</th>
              </tr>
              {hallDetails.map((hallDetail) => (
                <tr key={hallDetail.id}>
                  <td>
                    {parse(
                      `<span class="headings">${hallDetail.heading}</span>`
                    )}
                    {/* {hallDetail.image &&
                      parse(
                        `<img src=${hallDetail.image} style="float: right;width: 350px"/>`
                      )} */}
                    {parse(
                      handleContent(
                        hallDetail.contentTypeId,
                        hallDetail.content
                      )
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  return contents;
}

export default Halls;
